import { api } from '@/api';

export interface GetDraftVersionRequest {
  draftVersionId: string;
  citationIndexMap: Record<string, number>;
}

export interface GetDraftVersionResponse {
  title: string;
  content: string;
}

const getDraftVersionApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getDraftVersion: builder.mutation<GetDraftVersionResponse, GetDraftVersionRequest>({
      query: (body) => ({
        url: '/chat/draft/get-version',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGetDraftVersionMutation } = getDraftVersionApi;
